import React from "react";
import {Outlet} from "react-router-dom";
import {useAuth} from "@/app/AuthContext";
import {Menu} from "@/components/icons";
import {Sidebar} from "@/components/sidebar";
import Navbar from "@/components/navbar";
import {useSidebarState} from "@/hooks/useSidebarState";
import {useWsEvents} from "@/hooks/useWsEvents";
import {Button} from "@/components/ui/button";
import {nav, isNavItemVisible} from "@/app/navigation";
import {DashboardOrgProvider} from "@/app/DashboardOrgContext";
import {useT} from "@/app/localization";

export function AppShell() {
    const {user, isAdmin, isReadOnlyAdmin, isAdminViewer, isFree, isManager} = useAuth();
    const t = useT();
    const {collapsed, toggle} = useSidebarState();
    useWsEvents();
    const [mobileOpen, setMobileOpen] = React.useState(false);

    const visibleNav = nav.filter((item) => isNavItemVisible(item, {isAdmin, isAdminViewer, isManager, isFree}));

    const sidebarWidth = collapsed ? "w-[76px]" : "w-[250px]";

    return (
        <DashboardOrgProvider>
        <div className="flex h-screen overflow-hidden" style={{"--sidebar-width": collapsed ? "76px" : "250px"} as React.CSSProperties}>
            <div className={`hidden lg:flex flex-shrink-0 ${sidebarWidth} transition-[width] duration-200 ease-out relative z-50`}>
                <Sidebar
                    collapsed={collapsed}
                    onToggleCollapsed={toggle}
                    items={visibleNav}
                />
            </div>

            {mobileOpen && (
                <div className="fixed inset-0 z-[999] lg:hidden">
                    <div className="absolute inset-0 bg-black/30" onClick={() => setMobileOpen(false)} />
                    <div className="relative z-10 h-full w-[250px]">
                        <Sidebar
                            collapsed={false}
                            onToggleCollapsed={() => setMobileOpen(false)}
                            items={visibleNav}
                            mobile
                        />
                    </div>
                </div>
            )}

            <div className="flex flex-1 flex-col min-w-0">
                <div className="sticky top-0 z-40 flex-shrink-0">
                    <div className="flex items-center">
                        <Button
                            variant="ghost"
                            size="sm"
                            className="lg:hidden ml-2"
                            aria-label={t("operator.shell.nav_open")}
                            onClick={() => setMobileOpen(true)}
                        >
                            <Menu className="h-5 w-5" />
                        </Button>
                        <div className="flex-1 header flex items-center">
                            <div className="flex-1"><Navbar user={user} /></div>
                        </div>
                    </div>
                </div>

                {isReadOnlyAdmin && (
                    <div
                        role="status"
                        className="flex-shrink-0 bg-warning/15 text-warning-content border-b border-warning/30 px-6 py-1.5 text-center text-xs font-medium"
                    >
                        Read-only admin — you can view everything but cannot make changes.
                    </div>
                )}
                <div className="flex-1 overflow-y-auto px-6 pb-6">
                    <Outlet />
                </div>
            </div>
        </div>
        </DashboardOrgProvider>
    );
}
